import { format, parse } from "date-fns";

// The API's ISO calendar dates and clock times, read and written on the local day: never `new Date(value)` or
// `toISOString()`, which use UTC and can shift the day.
export const isoDate = (value: string) => parse(value, "yyyy-MM-dd", new Date());
export const isoTime = (value: string) => parse(value, "HH:mm", new Date());
export const toIsoDate = (date: Date) => format(date, "yyyy-MM-dd");

// The API's `duration_minutes` as hours and minutes, for `intl.formatDuration` (which doesn't carry 90 min into hours).
export const durationFromMinutes = (minutes: number) => ({ hours: Math.floor(minutes / 60), minutes: minutes % 60 });
